'use strict';

const _=require('pulsar-utils/dist-es6/_');
const HeatmapGroupViewModel=require('../../../dist-es6/client/viewModels/heatmapGroupViewModel');
const PseudoGroup=require('../../../dist-es6/client/domain/pseudoGroup');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');

const MaxDepth=2;let

HeatmapService=class HeatmapService extends BaseService{
static get $inject(){return[]}

constructor(){
super();
}

getMaxAvailableDepth(group,maxDepth=MaxDepth,currentDepth=0){
maxDepth=Math.min(maxDepth,MaxDepth);

const{children}=group;
return children.length&&currentDepth<maxDepth?
_.max(children.map(child=>this.getMaxAvailableDepth(child,maxDepth,currentDepth+1))):
currentDepth;
}

getLeafGroups(groupTree){
if(_.exists(this._lastGroupTreeForLeafGroups)&&this._lastGroupTreeForLeafGroups===groupTree){
return this._lastLeafGroupsResult;
}

const maxAvailableDepth=this.getMaxAvailableDepth(groupTree);
const leafGroups=[];
_walkTreeFromRoot(groupTree,(group,currentDepth,currentPath)=>{
if(currentDepth!==maxAvailableDepth)
return;

leafGroups.push(group);
});

this._lastGroupTreeForLeafGroups=groupTree;
this._lastLeafGroupsResult=leafGroups;

return this._lastLeafGroupsResult;
}

setColSpansForLeafGroups(groupTree,numLeafColumns){
const leafGroups=this.getLeafGroups(groupTree);
for(const groupIndex in leafGroups){
leafGroups[groupIndex].colSpan=numLeafColumns[groupIndex];
};
}

determineColSpansForLeafGroups(groupTree,personHeight,heatmapHeight,filteredPersonIds=null){
const useFilter=_.exists(filteredPersonIds)&&groupTree.aggregatePersons.length!==filteredPersonIds.length;

let leafColSpans=[];
let filteredLeafColSpans=[];
for(const group of this.getLeafGroups(groupTree)){
const persons=group.aggregatePersons||group.directPersons;

const numUnfilteredColSpans=this.getNumColumnsFor(persons.length,personHeight,heatmapHeight);
leafColSpans.push(numUnfilteredColSpans);

let numFilteredColSpans=numUnfilteredColSpans;
if(useFilter){
const filteredPersonsInGroup=persons.filter(p=>filteredPersonIds.includes(p.id));
numFilteredColSpans=this.getNumColumnsFor(filteredPersonsInGroup.length,personHeight,heatmapHeight);
}
filteredLeafColSpans.push(numFilteredColSpans);
};

return{leafColSpans,filteredLeafColSpans};
}

getNumColumnsFor(numPersons,personHeight,heatmapHeight){
if(personHeight>heatmapHeight){
throw new Error('personHeight cannot be greater than heatmapHeight.');
}
const maxPersonsPerColumn=Math.floor(heatmapHeight/personHeight);
const maxPersonAreaHeight=maxPersonsPerColumn*personHeight;
return Math.ceil(personHeight*numPersons/maxPersonAreaHeight)||1;
}

getLongestNamesByDepth(groupTree){
const maxAvailableDepth=this.getMaxAvailableDepth(groupTree);

let longestNamesByDepth={};
_walkTreeFromRoot(groupTree,(group,currentDepth)=>{
const longestNameAtDepth=longestNamesByDepth[currentDepth];

if(!_.exists(longestNameAtDepth)||group.name.length>longestNamesByDepth.length){
longestNamesByDepth[currentDepth]=group.name;
}

if(currentDepth===maxAvailableDepth){
const persons=group.aggregatePersons||group.directPersons;
for(const person of persons){
if(!_.exists(longestNamesByDepth.person)||person.name.length>longestNamesByDepth.person.length){
longestNamesByDepth.person=person.name;
}
}
}
});

return longestNamesByDepth;
}

getMaxNumPersonsInLeafGroups(groupTree){
return _.max(this.getLeafGroups(groupTree).
map(g=>_.exists(g.aggregatePersons)?
g.aggregatePersons.length:
g.directPersons.length));
}

getWithDirectPersonsMovedToPseudoGroupAtDepth(parentGroup,depth){
const clonedGroup=HeatmapGroupViewModel.cloneFromGroupStatisticsViewModel(parentGroup);

if(depth===0){
return clonedGroup;
}

const{directPersons,children}=clonedGroup;

if(children.length>0&&directPersons.length===0&&depth>0){
return clonedGroup;
}

let lastChild;
let currentDepth=depth;
while(currentDepth-->0){
if(!_.exists(lastChild)){
lastChild=new PseudoGroup({
directPersons,
name:_getNameForDepth(currentDepth),
parentGroupName:clonedGroup.name,
parentGroupId:clonedGroup.id});


continue;
}

lastChild=new PseudoGroup({
name:_getNameForDepth(currentDepth),
parentGroupName:clonedGroup.name,
parentGroupId:clonedGroup.id,
children:[lastChild]});

}

clonedGroup.children=children.concat([lastChild]);

return clonedGroup;
}

constructHeatmapViewModelTree(groupTree){
const maxAvailableDepth=this.getMaxAvailableDepth(groupTree);

let newTree={};
_walkTreeFromRoot(groupTree,(group,currentDepth,currentPath)=>{
const distanceFromBottom=maxAvailableDepth-currentDepth;
const newGroup=this.getWithDirectPersonsMovedToPseudoGroupAtDepth(group,distanceFromBottom);
if(currentPath===''){
newTree=newGroup;
return;
}

_.set(newTree,currentPath,newGroup);
});

return newTree;
}

getGroupBreadcrumbs(selectedGroup,rootGroup){
let breadcrumbs=[];

_climbTreeFromChildren(rootGroup,(currentGroup,currentDepth,currentPath)=>{
for(const crumb of breadcrumbs){
if(currentGroup.children.map(g=>g.id).includes(crumb.id)){
breadcrumbs.push(currentGroup);
return;
}
}
if(currentGroup.id===selectedGroup.id){
breadcrumbs.push(currentGroup);
}
});

return breadcrumbs.reverse();
}};


function _getNameForDepth(depth){
return depth===0?'--':'';
}

function _walkTreeFromRoot(group,fn,currentDepth=0,currentPath=''){
fn(group,currentDepth,currentPath);

const nextDepth=currentDepth+1;
if(nextDepth>MaxDepth){
return;
}

for(const[index,child]of group.children.entries()){
_walkTreeFromRoot(child,fn,nextDepth,currentPath+`${currentDepth>0?'.':''}children.${index}`);
}
}

function _climbTreeFromChildren(group,fn,currentDepth=0,currentPath=''){
const nextDepth=currentDepth+1;

if(group.children.length>0){
for(const[index,child]of group.children.entries()){
_climbTreeFromChildren(child,fn,nextDepth,currentPath+`${currentDepth>0?'.':''}children.${index}`);
}
}

fn(group,currentDepth,currentPath);
}

module.exports=HeatmapService;
module.exports.MaxDepth=MaxDepth;
//# sourceMappingURL=heatmapService.js.map
